<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("autoemailreport") }}</div>
      <router-link
        v-if="$can('create', 'Auto Email Report')"
        class="btn-blue"
        to="add-auto-emailer-v2"
        >{{ $t("add") }}
      </router-link>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <router-link class="btn-blue" to="auto-emailer-v2-logs"
          >{{ $t("logs") }}
        </router-link>

        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              this.GetAllAutoEmailReport(filterIsActive);
            }
          "
        />
        <div class>
          <b-dropdown id="listview" name="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              href="#"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="white-wrapper my-3">
      <!-- 1 Distributer -->
      <section v-if="true" class="mb-4 w-100 px-3 section-new">
        <div
          class="section-title mb-3 d-flex justify-content-between section-collapse-box"
          style="padding: 6px; align-items: center"
          v-b-toggle.distributorSummaryReport
        >
          <span class="fs">
            {{ $tc("Distributor Summary Report", 2) }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="distributorSummaryReport"
          class="mt-2"
          v-model="sectionCollapse.distributorSummaryReport"
        >
          <div class="pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <table class="list-view-table" border="1">
                <thead>
                  <tr>
                    <th style="width: 80px">{{ $tc("Sr. No.") }}</th>
                    <th class="text-center">
                      <span class="pr-3">{{ $tc("status", 2) }}</span>
                    </th>
                    <!-- <th class="text-left">
                      {{ $t("report") }} {{ $t("name") }}
                    </th> -->
                    <th class="text-center">
                      {{ $t("cinema") }} {{ $t("name") }}
                    </th>
                    <th class="text-center">{{ $t("frequency") }}</th>
                    <th class="text-center">{{ $t("screens") }}</th>
                  </tr>
                </thead>
                <tbody v-if="distributorSummaryReportList.length > 0">
                  <tr
                    v-for="(
                      emailreport, emailreportIndex
                    ) in distributorSummaryReportList"
                    :key="emailreportIndex"
                  >
                    <td style="text-align: right">
                      {{ emailreportIndex + 1 }}
                    </td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <StatusDot
                          :status="
                            emailreport.is_active === 'Y'
                              ? 'active'
                              : 'inactive'
                          "
                        />
                        <i
                          class="edit-pen icon blue-icon cursor-pointer ml-4"
                          @click="onEmailReport('Edit', emailreport)"
                          tabindex="0"
                          v-b-tooltip="'Edit'"
                        >
                        </i>
                      </div>
                    </td>

                    <!-- <td class="text-center">
                      {{ getReportName(emailreport.report_type) }}
                    </td> -->
                    <td class="text-left">{{ emailreport.cine_name }}</td>
                    <td class="text-left">
                      {{ getFrequencyName(emailreport.frequency_type) }}
                    </td>

                    <!-- <td class="text-center">
                      {{
                        emailreport.screens.map((s) => s.screen_name).join(",")
                      }}
                    </td> -->
                    <td class="text-left">
                      {{
                        emailreport.screens && emailreport.screens.length > 0
                          ? emailreport.screens
                              .map((s) => s.screen_name)
                              .join(",")
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5">
                      <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                      <NoRecords />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- 2 aggregator -->
      <section v-if="true" class="mb-4 w-100 px-3 section-new">
        <div
          class="section-title mb-3 d-flex justify-content-between section-collapse-box"
          style="padding: 6px; align-items: center"
          v-b-toggle.aggregatorsalesreport
        >
          <span class="fs">
            {{ $tc("Aggregator Sales Report", 2) }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="aggregatorsalesreport"
          class="mt-2"
          v-model="sectionCollapse.aggregatorsalesreport"
        >
          <div class="pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <table class="list-view-table" border="1">
                <thead>
                  <tr>
                    <th style="width: 80px">{{ $tc("Sr. No.") }}</th>
                    <th class="text-center">
                      <span class="pr-3">{{ $tc("status", 2) }}</span>
                    </th>
                    <!-- <th class="text-center">
                      {{ $t("report") }} {{ $t("name") }}
                    </th> -->
                    <th class="text-center">
                      {{ $t("cinema") }} {{ $t("name") }}
                    </th>
                    <th class="text-center">{{ $t("frequency") }}</th>
                    <th class="text-center">{{ $t("screens") }}</th>
                  </tr>
                </thead>
                <tbody v-if="aggregatorSaleReportList.length > 0">
                  <tr
                    v-for="(
                      emailreport, emailreportIndex
                    ) in aggregatorSaleReportList"
                    :key="emailreportIndex"
                  >
                    <td style="text-align: right">
                      {{ emailreportIndex + 1 }}
                    </td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <StatusDot
                          :status="
                            emailreport.is_active === 'Y'
                              ? 'active'
                              : 'inactive'
                          "
                        />
                        <i
                          class="edit-pen icon blue-icon cursor-pointer ml-4"
                          @click="onEmailReport('Edit', emailreport)"
                          tabindex="0"
                          v-b-tooltip="'Edit'"
                        >
                        </i>
                      </div>
                    </td>

                    <!-- <td class="text-center">
                      {{ getReportName(emailreport.report_type) }}
                    </td> -->
                    <td class="text-left">{{ emailreport.cine_name }}</td>
                    <td class="text-left">
                      {{ getFrequencyName(emailreport.frequency_type) }}
                    </td>

                    <!-- <td class="text-center">
                      {{
                        emailreport.screens.map((s) => s.screen_name).join(",")
                      }}
                    </td> -->
                    <td class="text-left">
                      {{
                        emailreport.screens && emailreport.screens.length > 0
                          ? emailreport.screens
                              .map((s) => s.screen_name)
                              .join(",")
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5">
                      <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                      <NoRecords />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- 3 Summary and performance report -->
      <section v-if="true" class="mb-4 w-100 px-3 section-new">
        <div
          class="section-title mb-3 d-flex justify-content-between section-collapse-box"
          style="padding: 6px; align-items: center"
          v-b-toggle.summaryandperformancereport
        >
          <span class="fs">
            {{ $tc("Summary & Performance Report", 2) }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="summaryandperformancereport"
          class="mt-2"
          v-model="sectionCollapse.summaryandperformancereport"
        >
          <div class="pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <table class="list-view-table" border="1">
                <thead>
                  <tr>
                    <th style="width: 80px">{{ $tc("Sr. No.") }}</th>
                    <th class="text-center">
                      <span class="pr-3">{{ $tc("status", 2) }}</span>
                    </th>
                    <!-- <th class="text-center">
                      {{ $t("report") }} {{ $t("name") }}
                    </th> -->
                    <th class="text-center">
                      {{ $t("cinema") }} {{ $t("name") }}
                    </th>
                    <th class="text-center">{{ $t("frequency") }}</th>
                    <th class="text-center">{{ $t("screens") }}</th>
                  </tr>
                </thead>
                <tbody v-if="summaryAndPerformance.length > 0">
                  <tr
                    v-for="(
                      emailreport, emailreportIndex
                    ) in summaryAndPerformance"
                    :key="emailreportIndex"
                  >
                    <td style="text-align: right">
                      {{ emailreportIndex + 1 }}
                    </td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <StatusDot
                          :status="
                            emailreport.is_active === 'Y'
                              ? 'active'
                              : 'inactive'
                          "
                        />
                        <i
                          class="edit-pen icon blue-icon cursor-pointer ml-4"
                          @click="onEmailReport('Edit', emailreport)"
                          tabindex="0"
                          v-b-tooltip="'Edit'"
                        >
                        </i>
                      </div>
                    </td>

                    <!-- <td class="text-center">
                      {{ getReportName(emailreport.report_type) }}
                    </td> -->
                    <td class="text-left">{{ emailreport.cine_name }}</td>
                    <td class="text-left">
                      {{ getFrequencyName(emailreport.frequency_type) }}
                    </td>

                    <!-- <td class="text-center">
                      {{
                        emailreport.screens.map((s) => s.screen_name).join(",")
                      }}
                    </td> -->
                    <td class="text-left">
                      {{
                        emailreport.screens && emailreport.screens.length > 0
                          ? emailreport.screens
                              .map((s) => s.screen_name)
                              .join(",")
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5">
                      <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                      <NoRecords />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- 4 Box Office Summary Report -->
      <section v-if="true" class="mb-4 w-100 px-3 section-new">
        <div
          class="section-title mb-3 d-flex justify-content-between section-collapse-box"
          style="padding: 6px; align-items: center"
          v-b-toggle.boxofficesummaryreport
        >
          <span class="fs">
            {{ $tc("BoxOffice Summary Report", 2) }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="boxofficesummaryreport"
          class="mt-2"
          v-model="sectionCollapse.boxofficesummaryreport"
        >
          <div class="pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <table class="list-view-table" border="1">
                <thead>
                  <tr>
                    <th style="width: 80px">{{ $tc("Sr. No.") }}</th>
                    <th class="text-center">
                      <span class="pr-3">{{ $tc("status", 2) }}</span>
                    </th>
                    <!-- <th class="text-center">
                      {{ $t("report") }} {{ $t("name") }}
                    </th> -->
                    <th class="text-center">
                      {{ $t("cinema") }} {{ $t("name") }}
                    </th>
                    <th class="text-center">{{ $t("frequency") }}</th>
                    <th class="text-center">{{ $t("screens") }}</th>
                  </tr>
                </thead>
                <tbody v-if="BoxOfficeSummaryReport.length > 0">
                  <tr
                    v-for="(
                      emailreport, emailreportIndex
                    ) in BoxOfficeSummaryReport"
                    :key="emailreportIndex"
                  >
                    <td style="text-align: right">
                      {{ emailreportIndex + 1 }}
                    </td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <StatusDot
                          :status="
                            emailreport.is_active === 'Y'
                              ? 'active'
                              : 'inactive'
                          "
                        />
                        <i
                          class="edit-pen icon blue-icon cursor-pointer ml-4"
                          @click="onEmailReport('Edit', emailreport)"
                          tabindex="0"
                          v-b-tooltip="'Edit'"
                        >
                        </i>
                      </div>
                    </td>

                    <!-- <td class="text-center">
                      {{ getReportName(emailreport.report_type) }}
                    </td> -->
                    <td class="text-left">{{ emailreport.cine_name }}</td>
                    <td class="text-left">
                      {{ getFrequencyName(emailreport.frequency_type) }}
                    </td>

                    <!-- <td class="text-center">
                      {{
                        emailreport.screens.map((s) => s.screen_name).join(",")
                      }}
                    </td> -->
                    <td class="text-left">
                      {{
                        emailreport.screens && emailreport.screens.length > 0
                          ? emailreport.screens
                              .map((s) => s.screen_name)
                              .join(",")
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="4">
                      <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                      <NoRecords />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- 5 Distributer Collection Report -->
      <section v-if="true" class="mb-4 w-100 px-3 section-new">
        <div
          class="section-title mb-3 d-flex justify-content-between section-collapse-box"
          style="padding: 6px; align-items: center"
          v-b-toggle.distributorcollectionReport
        >
          <span class="fs">
            {{ $tc("Distributor Collection Report", 2) }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="distributorcollectionReport"
          class="mt-2"
          v-model="sectionCollapse.distributorcollectionReport"
        >
          <div class="pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <table class="list-view-table" border="1">
                <thead>
                  <tr>
                    <th style="width: 80px">{{ $tc("Sr. No.") }}</th>
                    <th class="text-center">
                      <span class="pr-3">{{ $tc("status", 2) }}</span>
                    </th>
                    <!-- <th class="text-center">
                      {{ $t("report") }} {{ $t("name") }}
                    </th> -->
                    <th class="text-center">
                      {{ $t("cinema") }} {{ $t("name") }}
                    </th>
                    <th class="text-center">{{ $t("frequency") }}</th>
                    <th class="text-center">{{ $t("screens") }}</th>
                  </tr>
                </thead>
                <tbody v-if="DistributorCollectionReport.length > 0">
                  <tr
                    v-for="(
                      emailreport, emailreportIndex
                    ) in DistributorCollectionReport"
                    :key="emailreportIndex"
                  >
                    <td style="text-align: right">
                      {{ emailreportIndex + 1 }}
                    </td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <StatusDot
                          :status="
                            emailreport.is_active === 'Y'
                              ? 'active'
                              : 'inactive'
                          "
                        />
                        <i
                          class="edit-pen icon blue-icon cursor-pointer ml-4"
                          @click="onEmailReport('Edit', emailreport)"
                          tabindex="0"
                          v-b-tooltip="'Edit'"
                        >
                        </i>
                      </div>
                    </td>

                    <!-- <td class="text-center">
                      {{ getReportName(emailreport.report_type) }}
                    </td> -->
                    <td class="text-left">{{ emailreport.cine_name }}</td>
                    <td class="text-left">
                      {{ getFrequencyName(emailreport.frequency_type) }}
                    </td>

                    <!-- <td class="text-center">
                      {{
                        emailreport.screens.map((s) => s.screen_name).join(",")
                      }}
                    </td> -->
                    <td class="text-left">
                      {{
                        emailreport.screens && emailreport.screens.length > 0
                          ? emailreport.screens
                              .map((s) => s.screen_name)
                              .join(",")
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5">
                      <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                      <NoRecords />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- 6 Distributor report M- Tax -->
      <section v-if="true" class="mb-4 w-100 px-3 section-new">
        <div
          class="section-title mb-3 d-flex justify-content-between section-collapse-box"
          style="padding: 6px; align-items: center"
          v-b-toggle.distributorReportmtax
        >
          <span class="fs">
            {{ $tc("Distributor Report (with M-TAX)", 2) }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="distributorReportmtax"
          class="mt-2"
          v-model="sectionCollapse.distributorReportmtax"
        >
          <div class="pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <table class="list-view-table" border="1">
                <thead>
                  <tr>
                    <th style="width: 80px">{{ $tc("Sr. No.") }}</th>
                    <th class="text-center">
                      <span class="pr-3">{{ $tc("status", 2) }}</span>
                    </th>
                    <!-- <th class="text-center">
                      {{ $t("report") }} {{ $t("name") }}
                    </th> -->
                    <th class="text-center">
                      {{ $t("cinema") }} {{ $t("name") }}
                    </th>
                    <th class="text-center">{{ $t("frequency") }}</th>
                    <th class="text-center">{{ $t("screens") }}</th>
                  </tr>
                </thead>
                <tbody v-if="DistributorReportMTax.length > 0">
                  <tr
                    v-for="(
                      emailreport, emailreportIndex
                    ) in DistributorReportMTax"
                    :key="emailreportIndex"
                  >
                    <td style="text-align: right">
                      {{ emailreportIndex + 1 }}
                    </td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <StatusDot
                          :status="
                            emailreport.is_active === 'Y'
                              ? 'active'
                              : 'inactive'
                          "
                        />
                        <i
                          class="edit-pen icon blue-icon cursor-pointer ml-4"
                          @click="onEmailReport('Edit', emailreport)"
                          tabindex="0"
                          v-b-tooltip="'Edit'"
                        >
                        </i>
                      </div>
                    </td>

                    <!-- <td class="text-center">
                      {{ getReportName(emailreport.report_type) }}
                    </td> -->
                    <td class="text-left">{{ emailreport.cine_name }}</td>
                    <td class="text-left">
                      {{ getFrequencyName(emailreport.frequency_type) }}
                    </td>

                    <!-- <td class="text-center">
                      {{
                        emailreport.screens.map((s) => s.screen_name).join(",")
                      }}
                    </td> -->
                    <td class="text-left">
                      {{
                        emailreport.screens && emailreport.screens.length > 0
                          ? emailreport.screens
                              .map((s) => s.screen_name)
                              .join(",")
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5">
                      <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                      <NoRecords />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- Distributor Report CNPLS -->
      <section class="mb-4 w-100 px-3 section-new">
        <div
          class="section-title mb-3 d-flex justify-content-between section-collapse-box"
          style="padding: 6px; align-items: center"
          v-b-toggle.distributorReportOman
        >
          <span class="fs">
            {{ "Distributor Report (CNPLS)" }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="distributorReportOman"
          class="mt-2"
          v-model="sectionCollapse.distributorReportOman"
        >
          <div class="pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <table class="list-view-table" border="1">
                <thead>
                  <tr>
                    <th style="width: 80px">{{ $tc("Sr. No.") }}</th>
                    <th class="text-center">
                      <span class="pr-3">{{ $tc("status", 2) }}</span>
                    </th>
                    <!-- <th class="text-center">
                    {{ $t("report") }} {{ $t("name") }}
                  </th> -->
                    <th class="text-center">
                      {{ $t("cinema") }} {{ $t("name") }}
                    </th>
                    <th class="text-center">{{ $t("frequency") }}</th>
                    <th class="text-center">{{ $t("screens") }}</th>
                  </tr>
                </thead>
                <tbody v-if="DistributorReportOman.length > 0">
                  <tr
                    v-for="(
                      emailreport, emailreportIndex
                    ) in DistributorReportOman"
                    :key="emailreportIndex"
                  >
                    <td style="text-align: right">
                      {{ emailreportIndex + 1 }}
                    </td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <StatusDot
                          :status="
                            emailreport.is_active === 'Y'
                              ? 'active'
                              : 'inactive'
                          "
                        />
                        <i
                          class="edit-pen icon blue-icon cursor-pointer ml-4"
                          @click="onEmailReport('Edit', emailreport)"
                          tabindex="0"
                          v-b-tooltip="'Edit'"
                        >
                        </i>
                      </div>
                    </td>

                    <!-- <td class="text-center">
                    {{ getReportName(emailreport.report_type) }}
                  </td> -->
                    <td class="text-left">{{ emailreport.cine_name }}</td>
                    <td class="text-left">
                      {{ getFrequencyName(emailreport.frequency_type) }}
                    </td>

                    <!-- <td class="text-center">
                    {{
                      emailreport.screens.map((s) => s.screen_name).join(",")
                    }}
                  </td> -->
                    <td class="text-left">
                      {{
                        emailreport.screens && emailreport.screens.length > 0
                          ? emailreport.screens
                              .map((s) => s.screen_name)
                              .join(",")
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5">
                      <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                      <NoRecords />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- Distributor Report Epix -->
      <section class="mb-4 w-100 px-3 section-new">
        <div
          class="section-title mb-3 d-flex justify-content-between section-collapse-box"
          style="padding: 6px; align-items: center"
          v-b-toggle.distributorReportEpix
        >
          <span class="fs">
            {{ "Distributor Report (Epix)" }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="distributorReportEpix"
          class="mt-2"
          v-model="sectionCollapse.distributorReportEpix"
        >
          <div class="pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <table class="list-view-table" border="1">
                <thead>
                  <tr>
                    <th style="width: 80px">{{ $tc("Sr. No.") }}</th>
                    <th class="text-center">
                      <span class="pr-3">{{ $tc("status", 2) }}</span>
                    </th>
                    <!-- <th class="text-center">
                    {{ $t("report") }} {{ $t("name") }}
                  </th> -->
                    <th class="text-center">
                      {{ $t("cinema") }} {{ $t("name") }}
                    </th>
                    <th class="text-center">{{ $t("frequency") }}</th>
                    <th class="text-center">{{ $t("screens") }}</th>
                  </tr>
                </thead>
                <tbody v-if="DistributorReportEpix.length > 0">
                  <tr
                    v-for="(
                      emailreport, emailreportIndex
                    ) in DistributorReportEpix"
                    :key="emailreportIndex"
                  >
                    <td style="text-align: right">
                      {{ emailreportIndex + 1 }}
                    </td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <StatusDot
                          :status="
                            emailreport.is_active === 'Y'
                              ? 'active'
                              : 'inactive'
                          "
                        />
                        <i
                          class="edit-pen icon blue-icon cursor-pointer ml-4"
                          @click="onEmailReport('Edit', emailreport)"
                          tabindex="0"
                          v-b-tooltip="'Edit'"
                        >
                        </i>
                      </div>
                    </td>

                    <!-- <td class="text-center">
                    {{ getReportName(emailreport.report_type) }}
                  </td> -->
                    <td class="text-left">{{ emailreport.cine_name }}</td>
                    <td class="text-left">
                      {{ getFrequencyName(emailreport.frequency_type) }}
                    </td>

                    <!-- <td class="text-center">
                    {{
                      emailreport.screens.map((s) => s.screen_name).join(",")
                    }}
                  </td> -->
                    <td class="text-left">
                      {{
                        emailreport.screens && emailreport.screens.length > 0
                          ? emailreport.screens
                              .map((s) => s.screen_name)
                              .join(",")
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5">
                      <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                      <NoRecords />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- Distributor Report Epix -->

      <!-- Distributor Report Play -->
      <section class="mb-4 w-100 px-3 section-new">
        <div
          class="section-title mb-3 d-flex justify-content-between section-collapse-box"
          style="padding: 6px; align-items: center"
          v-b-toggle.distributorReportPlay
        >
          <span class="fs">
            {{ "Distributor Report Play Cinema" }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="distributorReportPlay"
          class="mt-2"
          v-model="sectionCollapse.distributorReportPlay"
        >
          <div class="pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <table class="list-view-table" border="1">
                <thead>
                  <tr>
                    <th style="width: 80px">{{ $tc("Sr. No.") }}</th>
                    <th class="text-center">
                      <span class="pr-3">{{ $tc("status", 2) }}</span>
                    </th>
                    <!-- <th class="text-center">
                    {{ $t("report") }} {{ $t("name") }}
                  </th> -->
                    <th class="text-center">
                      {{ $t("cinema") }} {{ $t("name") }}
                    </th>
                    <th class="text-center">{{ $t("frequency") }}</th>
                    <th class="text-center">{{ $t("screens") }}</th>
                  </tr>
                </thead>
                <tbody v-if="DistributorReportPlay.length > 0">
                  <tr
                    v-for="(
                      emailreport, emailreportIndex
                    ) in DistributorReportPlay"
                    :key="emailreportIndex"
                  >
                    <td style="text-align: right">
                      {{ emailreportIndex + 1 }}
                    </td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <StatusDot
                          :status="
                            emailreport.is_active === 'Y'
                              ? 'active'
                              : 'inactive'
                          "
                        />
                        <i
                          class="edit-pen icon blue-icon cursor-pointer ml-4"
                          @click="onEmailReport('Edit', emailreport)"
                          tabindex="0"
                          v-b-tooltip="'Edit'"
                        >
                        </i>
                      </div>
                    </td>

                    <!-- <td class="text-center">
                    {{ getReportName(emailreport.report_type) }}
                  </td> -->
                    <td class="text-left">{{ emailreport.cine_name }}</td>
                    <td class="text-left">
                      {{ getFrequencyName(emailreport.frequency_type) }}
                    </td>

                    <!-- <td class="text-center">
                    {{
                      emailreport.screens.map((s) => s.screen_name).join(",")
                    }}
                  </td> -->
                    <td class="text-left">
                      {{
                        emailreport.screens && emailreport.screens.length > 0
                          ? emailreport.screens
                              .map((s) => s.screen_name)
                              .join(",")
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5">
                      <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                      <NoRecords />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- Distributor Report CinemaAkhil -->
      <section class="mb-4 w-100 px-3 section-new">
        <div
          class="section-title mb-3 d-flex justify-content-between section-collapse-box"
          style="padding: 6px; align-items: center"
          v-b-toggle.distributorReportCinemaAkhilk
        >
          <span class="fs">
            {{ "Distributor Report CinemaAkhil" }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="distributorReportCinemaAkhilk"
          class="mt-2"
          v-model="sectionCollapse.distributorReportCinemaAkhilk"
        >
          <div class="pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <table class="list-view-table" border="1">
                <thead>
                  <tr>
                    <th style="width: 80px">{{ $tc("Sr. No.") }}</th>
                    <th class="text-center">
                      <span class="pr-3">{{ $tc("status", 2) }}</span>
                    </th>
                    <!-- <th class="text-center">
                    {{ $t("report") }} {{ $t("name") }}
                  </th> -->
                    <th class="text-center">
                      {{ $t("cinema") }} {{ $t("name") }}
                    </th>
                    <th class="text-center">{{ $t("frequency") }}</th>
                    <th class="text-center">{{ $t("screens") }}</th>
                  </tr>
                </thead>
                <tbody v-if="DistributorReportCinemaAkhilk.length > 0">
                  <tr
                    v-for="(
                      emailreport, emailreportIndex
                    ) in DistributorReportCinemaAkhilk"
                    :key="emailreportIndex"
                  >
                    <td style="text-align: right">
                      {{ emailreportIndex + 1 }}
                    </td>
                    <td>
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <StatusDot
                          :status="
                            emailreport.is_active === 'Y'
                              ? 'active'
                              : 'inactive'
                          "
                        />
                        <i
                          class="edit-pen icon blue-icon cursor-pointer ml-4"
                          @click="onEmailReport('Edit', emailreport)"
                          tabindex="0"
                          v-b-tooltip="'Edit'"
                        >
                        </i>
                      </div>
                    </td>

                    <!-- <td class="text-center">
                    {{ getReportName(emailreport.report_type) }}
                  </td> -->
                    <td class="text-left">{{ emailreport.cine_name }}</td>
                    <td class="text-left">
                      {{ getFrequencyName(emailreport.frequency_type) }}
                    </td>

                    <!-- <td class="text-center">
                    {{
                      emailreport.screens.map((s) => s.screen_name).join(",")
                    }}
                  </td> -->
                    <td class="text-left">
                      {{
                        emailreport.screens && emailreport.screens.length > 0
                          ? emailreport.screens
                              .map((s) => s.screen_name)
                              .join(",")
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5">
                      <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                      <NoRecords />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-collapse>
      </section>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 100,
      currentPage: 1,
      rows: 0,
      selectedvalue: "100",

      viewingnumbers: [],
      emailreoprtList: [],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      report_types: [
        {
          report_type: 1,
          name: "Distributor Summary Report",
        },
        {
          report_type: 2,
          name: "Aggregator Sales Report",
        },
        {
          report_type: 3,
          name: "Summary & Performance Report",
        },
        {
          report_type: 5,
          name: "BoxOffice Summary Report",
        },
        {
          report_type: 7,
          name: "Distributor Collection Report (Weekwise from Release Date)",
        },
        {
          report_type: 8,
          name: "Distributor Report (with M-TAX)",
        },
        {
          report_type: 10,
          name: "Distributor Report (CNPLS)",
        },
        {
          report_type: 11,
          name: "Distributor Report (Epix)",
        },
        {
          report_type: 12,
          name: "Distributor Report Play",
        },
        {
          report_type: 13,
          name: "Distributor Report CinemaAkhil",
        },
      ],
      frequency_type: [
        {
          frequency_type: 1,
          name: "Daily",
        },
        {
          frequency_type: 2,
          name: "Weekly",
        },
        {
          frequency_type: 3,
          name: "Monthly",
        },
      ],
      openSections: {
        1: false,
        2: false,
        3: false,
        5: false,
        7: false,
        8: false,
        9: false,
      },
      sectionCollapse: {
        distributorSummaryReport: false,
        aggregatorsalesreport: false,
        summaryandperformancereport: false,
        boxofficesummaryreport: false,
        distributorcollectionReport: false,
        distributorReportmtax: false,
        distributorReportOman: false,
        distributorReportEpix: false,
        distributorReportPlay: false,
        distributorReportCinemaAkhilk: false,
      },
    };
  },
  beforeMount() {
    this.GetAllAutoEmailReport();
    this.getviewingnumber();
  },
  computed: {
    distributorSummaryReportList() {
      return this.emailreoprtList.filter(
        (emailreport) => emailreport.report_type === 1
      );
    },
    aggregatorSaleReportList() {
      return this.emailreoprtList.filter(
        (emailreport) => emailreport.report_type === 2
      );
    },
    summaryAndPerformance() {
      return this.emailreoprtList.filter(
        (emailreport) => emailreport.report_type === 3
      );
    },
    BoxOfficeSummaryReport() {
      return this.emailreoprtList.filter(
        (emailreport) => emailreport.report_type === 5
      );
    },
    DistributorCollectionReport() {
      return this.emailreoprtList.filter(
        (emailreport) => emailreport.report_type === 7
      );
    },
    DistributorReportMTax() {
      return this.emailreoprtList.filter(
        (emailreport) => emailreport.report_type === 8
      );
    },
    DistributorReportOman() {
      return this.emailreoprtList.filter(
        (emailreport) => emailreport.report_type === 10
      );
    },
    DistributorReportEpix() {
      return this.emailreoprtList.filter(
        (emailreport) => emailreport.report_type === 11
      );
    },
    DistributorReportPlay() {
      return this.emailreoprtList.filter(
        (emailreport) => emailreport.report_type === 12
      );
    },
    DistributorReportCinemaAkhilk() {
      return this.emailreoprtList.filter(
        (emailreport) => emailreport.report_type === 13
      );
    },
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
        { name: "100", id: 6 },
      ];
    },

    getReportName(report_type) {
      return this.getSafe(
        () =>
          this.report_types.filter((t) => t.report_type == report_type)[0].name,
        "Report"
      );
    },
    getFrequencyName(frequency_type) {
      return this.getSafe(
        () =>
          this.frequency_type.filter(
            (t) => t.frequency_type == frequency_type
          )[0].name,
        "Frequency"
      );
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event)
      if (event === undefined) {
        this.currentPage = 1;
        this.GetAllAutoEmailReport();
      } else {
        this.currentPage = event;
        this.GetAllAutoEmailReport();
      }
    },

    onEmailReport: function (type, data) {
      if (type == "Edit") {
        this.$router.push({
          path: `/master/add-auto-emailer-v2/${data.am_id}`,
          query: { am_id: data.am_id },
        });
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.GetAllAutoEmailReport();
    },

    GetAllAutoEmailReport: function (filter_is_active = "Y") {
      let loader = this.$loading.show();

      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        filter_is_active: filter_is_active,
      };

      MasterService.GetAutoEmailReportV2(body)
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if (
              data.Records &&
              data.Records.data &&
              data.Records.data.length > 0
            ) {
              this.emailreoprtList = data.Records.data.sort((a, b) => {
                let c = true;

                c = a.report_type - b.report_type;

                if (c === 0) {
                  c = a.cinema_id - b.cinema_id;
                }

                if (c === 0) {
                  c = a.frequency_type - b.frequency_type;
                }

                if (c === 0) {
                  c = a.am_id - b.am_id;
                }

                return c;
              });

              this.emailreoprtList.forEach((e) => {
                e.email = this.getSafe(() => JSON.parse(e.emails), [])
                  .map((e) => e.email)
                  .join(",");
              });

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            }
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    onDisableAll() {
      this.DisableAll();
    },
    DisableAll() {
      let loader = this.$loading.show();

      MasterService.DisableAllAutoEmailReportV2({})
        .then((response) => {
          const { data } = response;

          if (data.status) {
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    toggleSection(report_types) {
      this.$set(this.openSections, report_types, !this.isOpen(report_types));
    },

    isOpen(report_types) {
      return this.openSections[report_types];
    },
    toggleSection(sectionNumber) {
      this.openSections[sectionNumber] = !this.openSections[sectionNumber];
    },
    isOpen(sectionNumber) {
      return this.openSections[sectionNumber];
    },
  },
};
</script>

<style>
.section-collapse-box {
  border: 1px solid var(--lightgrey);
  border-radius: 10px;
  padding: 10px;
}
</style>
<!-- end1 -->



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/AutoEmailerV2/autoemailnew.vue